import React from 'react';

import { ListImage, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import {
  ContractDetailsContainerStyled,
  UploadedLogosContainerStyled,
} from './style';

type ClientRequirementType = {
  drawingSize: string;
  frameColor: string;
  logoResolution: string;
  drawingMaterialType: string;
  roundedEdge: string;
  logo?: string[];
};

const ClientRequirements = ({
  drawingSize,
  frameColor,
  logoResolution,
  drawingMaterialType,
  roundedEdge,
  logo,
}: ClientRequirementType) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        CLIENT REQUIREMENT
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Size of Drawing :</Typography>

          <Typography className="value">{drawingSize}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Selected Frame Color :</Typography>

          <Typography className="value">{frameColor}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Uploaded Logo :</Typography>
          <UploadedLogosContainerStyled className="value">
            <ListImage
              imagesURL={logo?.map((singleLogo, idx) => ({
                id: `${idx + 1}`,
                URL: singleLogo,
              }))}
              imageHeight="143px"
              imageWidth="192px"
            />
          </UploadedLogosContainerStyled>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">SResolution of Logo :</Typography>

          <Typography className="value">{logoResolution}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Material Type of Drawing :</Typography>

          <Typography className="value">{drawingMaterialType}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Rounded Edge :</Typography>

          <Typography className="value">{roundedEdge}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default ClientRequirements;
